import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Mail, Phone, MapPin } from 'lucide-react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [settings, setSettings] = useState<any>({
    orgName: 'UNIFIG',
    orgDescription: 'União dos Deficientes Físicos de Iguatemi. Entidade civil privada sem fins lucrativos, dedicada ao atendimento multidisciplinar gratuito.',
    address: 'Av. Jardelino José Moreira, 2069 - Centro, Iguatemi - MS',
    phone: '(67) 3481-XXXX',
    email: 'michellicazelli@hotmail.com'
  });

  useEffect(() => {
    const fetchSettings = async () => {
      if (!db) return;
      try {
        const docRef = doc(db, 'settings', 'global');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setSettings(docSnap.data());
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-3">
              <img src="https://i.postimg.cc/fb1sNF1C/Unifig-Logo-fundo-transfarente.png" alt="Logo UNIFIG" className="h-10 w-auto" referrerPolicy="no-referrer" />
              <span className="font-bold text-xl tracking-tight text-white">
                {settings.orgName}
              </span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              {settings.orgDescription}
            </p>
            <p className="text-[10px] text-slate-500">CNPJ: 05.416.171/0001-10</p>
            <div className="flex space-x-4">
              {settings.instagram && <a href={settings.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors"><Instagram size={20} /></a>}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-6">Links Rápidos</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="hover:text-primary transition-colors">Início</Link></li>
              <li><Link to="/atividades" className="hover:text-primary transition-colors">Atividades</Link></li>
              <li><Link to="/sobre-nos" className="hover:text-primary transition-colors">Sobre nós</Link></li>
              <li><Link to="/contato" className="hover:text-primary transition-colors">Contato</Link></li>
              <li><Link to="/admin" className="hover:text-primary transition-colors">Área Administrativa</Link></li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-white font-semibold mb-6">Legal</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/politica-de-privacidade" className="hover:text-primary transition-colors">Política de Privacidade</Link></li>
              <li><Link to="/termos-de-uso" className="hover:text-primary transition-colors">Termos de Uso</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-6">Contato</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-primary shrink-0" />
                <span>{settings.address}</span>
              </li>
              {/* Phone removed as per requirements - no real number */}
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-primary shrink-0" />
                <span>{settings.email}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center text-xs text-slate-500">
          <p>© {currentYear} {settings.orgName}. Todos os direitos reservados.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <span>Utilidade Pública Lei nº 980/2002</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
